export function LeftForm({ ...rest }) {
  return <div className="col-md-6 col-lg-5 col-xl-4 mb-3" {...rest} />;
}

export function RightPreview({ ...rest }) {
  return <div className="col-md-6 col-lg-7 col-xl-8 mb-3" {...rest} />;
}
